module.exports = __webpack_public_path__ + "img/logo-nav.a7cf5c89.png";